import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'values' })
export class ObjectValuesPipe implements PipeTransform {
  transform(obj: any): any[] {
    if (Array.isArray(obj) || !(obj !== null && typeof obj === 'object')) {
      return obj;
    }

    return Object.keys(obj).map(k => obj[k]);
  }
}
